var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
var Format = require('d3-format');

var Display = function (_React$PureComponent) {
  _inherits(Display, _React$PureComponent);

  function Display(props) {
    _classCallCheck(this, Display);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this.format = Format.format(props.format || '0.2f');
    return _this;
  }

  Display.prototype.formatValue = function formatValue(v) {
    var t = typeof v === 'undefined' ? 'undefined' : _typeof(v);
    switch (t) {
      case 'object':
        return JSON.stringify(v);
      case 'number':
        return this.format(v);
      case 'string':
      default:
        return v;
    }
  };

  Display.prototype.render = function render() {
    var value = this.props.value;

    var v = value !== undefined ? value : this.props.var;
    return React.createElement(
      'span',
      null,
      this.formatValue(v)
    );
  };

  return Display;
}(React.PureComponent);

Display._idyll = {
  name: 'Display',
  tagType: 'closed',
  displayType: 'inline',
  props: [{
    name: 'value',
    type: 'any',
    example: 'x',
    description: 'The value to be displayed.'
  }, {
    name: 'format',
    type: 'string',
    example: '"0.2f"',
    description: 'The format to use, powered by [d3-format](https://github.com/d3/d3-format).'
  }]
};

export default Display;